import { render, staticRenderFns } from "./TypeSettingOptions.vue?vue&type=template&id=bf6386a2&scoped=true&"
import script from "./TypeSettingOptions.vue?vue&type=script&lang=js&"
export * from "./TypeSettingOptions.vue?vue&type=script&lang=js&"
import style0 from "./TypeSettingOptions.vue?vue&type=style&index=0&id=bf6386a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6386a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
